import { createTRPCClient, httpBatchLink } from "@trpc/client";
function validateApiKey(apiKey) {
    if (!apiKey.startsWith("as_")) {
        throw new Error("Invalid admin secret API key. It must starts with as_");
    }
    return apiKey;
}
export function createTrpc(options) {
    const { apiKey } = options;
    return createTRPCClient({
        links: [
            () => ({ next, op }) => {
                op.path = `sdkAdmin.${op.path}`;
                return next(op);
            },
            httpBatchLink({
                url: options.serverUrl ?? "https://api.crablr.io",
                headers: typeof apiKey === "string"
                    ? {
                        authorization: `ApiKey ${validateApiKey(apiKey)}`,
                    }
                    : async () => ({
                        authorization: `ApiKey ${validateApiKey(await apiKey())}`,
                    }),
            }),
        ],
    });
}
